import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpEventType,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AlertSseService } from 'src/app/core/services/alert-sse.service';
import { CommonService } from 'src/app/shared/service/common.service';

@Injectable()
export class ActivityInterceptor implements HttpInterceptor {
  private reconnectionAttempted = false;

  constructor(
    private readonly alertSseService: AlertSseService,
    private readonly commonService: CommonService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap({
        next: (event) => {
          if (event.type === HttpEventType.Response) {
            const response = event;
            const isSuccessful =
              response.status >= 200 && response.status < 300;

            if (isSuccessful) {
              const token = this.commonService.getlocalStorageItem('token');
              if (
                token &&
                this.alertSseService.needsReconnection() &&
                !this.reconnectionAttempted
              ) {
                this.reconnectionAttempted = true;

                this.alertSseService.reconnectOnActivity();
                setTimeout(() => {
                  this.reconnectionAttempted = false;
                }, 5000);
              }
            }
          }
        },
      })
    );
  }
}
